module.exports = __webpack_public_path__ + "static/media/ic_location_white.d8b69e98.svg";